export interface PatientOwnerOption {
  id: string;
  name: string;
  role?: string;
  currentOnly?: boolean;
}

interface PatientOwnerStaff {
  id: string;
  name: string;
  role?: string | null;
  status: string;
  is_doctor?: boolean | null;
}

interface CurrentPatientOwner {
  assignedOwnerStaffId: string | null;
  assignedOwnerName: string | null;
}

export const getPatientDoctorOwners = (staff: readonly PatientOwnerStaff[]): PatientOwnerOption[] =>
  staff
    .filter((member) => member.status === 'active' &&
      (member.is_doctor === true ||
        (/\b(doctor|endodontist|dentist)\b/i.test(member.role ?? '') &&
          !/\bassistant\b/i.test(member.role ?? ''))))
    .map((member) => ({ id: member.id, name: member.name, role: member.role ?? undefined }));

export const getPatientOwnerChoices = (
  doctors: readonly PatientOwnerOption[],
  current: CurrentPatientOwner | null | undefined,
): PatientOwnerOption[] => {
  if (!current?.assignedOwnerStaffId || doctors.some((owner) => owner.id === current.assignedOwnerStaffId)) {
    return [...doctors];
  }

  return [...doctors, {
    id: current.assignedOwnerStaffId,
    name: current.assignedOwnerName ?? 'Current owner',
    currentOnly: true,
  }];
};
